import { useIcon } from '../../../hooks/useIcon';
import { Box } from '../../Box/Box';
import type { IconProps } from '../types';
import { IconSaveSvg } from './IconSaveSvg';

export const IconSave: React.FC<IconProps> = (props) => {
  const iconProps = useIcon(props);
  return <Box component={IconSaveSvg} {...iconProps} />;
};
